import React, { useState } from 'react';

interface ForgotPasswordProps {
  onSuccess: () => void;
  onBackToLogin: () => void;
}

const ForgotPassword: React.FC<ForgotPasswordProps> = ({ onSuccess, onBackToLogin }) => {
  const [email, setEmail] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [success, setSuccess] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    setError('');
    setSuccess('');
  };

  const validateEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      setError('E-posta adresi gereklidir');
      return;
    }

    if (!validateEmail(email)) {
      setError('Geçerli bir e-posta adresi giriniz');
      return;
    }

    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const response = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Şifre sıfırlama isteği başarısız');
      }

      setSuccess(data.message || 'Şifre sıfırlama linki e-posta adresinize gönderildi!');
      
      setTimeout(() => {
        onSuccess();
      }, 2000);
      
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Şifre sıfırlama isteği başarısız');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-form">
        <h2>🔑 Şifremi Unuttum</h2>
        <p className="form-description">
          E-posta adresinizi girin, şifre sıfırlama linkini size gönderelim.
        </p>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">E-posta Adresi</label>
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={handleChange}
              required
              placeholder="ornek@email.com"
              className="form-input"
            />
          </div>

          {error && <div className="error-message">{error}</div>}
          {success && <div className="success-message">{success}</div>}

          <div className="form-actions">
            <button 
              type="submit" 
              disabled={loading} 
              className="auth-button primary"
            >
              {loading ? 'Gönderiliyor...' : 'Şifre Sıfırlama Linki Gönder'}
            </button>
            
            <button 
              type="button" 
              onClick={onBackToLogin}
              className="auth-button secondary"
              disabled={loading}
            >
              Girişe Geri Dön
            </button>
          </div>
        </form>

        <div className="auth-info">
          <h3>📧 Nasıl Çalışır?</h3>
          <ol>
            <li>E-posta adresinizi girin</li>
            <li>Size özel şifre sıfırlama linki gönderelim</li>
            <li>Link'e tıklayarak yeni şifrenizi oluşturun</li>
            <li>Yeni şifrenizle sisteme giriş yapın</li>
          </ol>
          
          <div className="security-note">
            <h4>🛡️ Güvenlik Notu</h4>
            <p>
              Şifre sıfırlama linkleri 24 saat geçerlidir. 
              Linki size gönderen kimsenin biz olduğumuzdan emin olun.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
